import dayjs from 'dayjs'
import { DeviceLogLevel } from '@/types/device'

export type DateRangeOption = '15m' | '1h' | '6h' | '24h'

export type AppLogFilterState = {
  search?: string
  level?: DeviceLogLevel
  dateRange?: DateRangeOption
  camera?: string
}

export const DEFAULT_FILTERS: AppLogFilterState = {}

const DATE_RANGE_HOURS: Record<DateRangeOption, number> = {
  '15m': 0.25,
  '1h': 1,
  '6h': 6,
  '24h': 24
}

export const getStartDate = (range: DateRangeOption | undefined) => {
  if (!range) return undefined
  return dayjs().subtract(DATE_RANGE_HOURS[range], 'hour').toISOString()
}
